(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hv-heading-labels-images"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleText {
    constructor(container) {
      this.container = container;
      this.trigger = container.querySelector('.heading-labels-images__collapsible-trigger');
      this.content = container.querySelector('.heading-labels-images__collapsible-content');
      this.contentInner = container.querySelector('.heading-labels-images__collapsible-text');
      
      this.init();
    }

    init() {
      if (!this.trigger || !this.content || !this.contentInner) return;
      
      this.trigger.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const isOpen = this.container.classList.contains('is-open');
      
      if (isOpen) {
        this.content.style.height = '0';
        this.container.classList.remove('is-open');
      } else {
        this.content.style.height = `${this.contentInner.offsetHeight}px`;
        this.container.classList.add('is-open');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const collapsible = document.querySelector('.heading-labels-images__collapsible');
    if (collapsible) {
      new CollapsibleText(collapsible);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hv-image-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.hv-image-tabs');

    sections.forEach(section => {
      const tabs = section.querySelectorAll('.hv-image-tabs__tab');
      const images = section.querySelectorAll('.hv-image-tabs__image');
      const imageContainer = section.querySelector('.hv-image-tabs__image-container');

      const updateContainerRadius = () => {
        if (!imageContainer) return;
        const activeIndex = Array.from(tabs).findIndex(t => t.classList.contains('hv-image-tabs__tab--active'));
        imageContainer.classList.remove('hv-image-tabs__image-container--no-top-left-radius', 'hv-image-tabs__image-container--no-top-right-radius');
        if (activeIndex === 0) {
          imageContainer.classList.add('hv-image-tabs__image-container--no-top-left-radius');
        } else if (activeIndex === tabs.length - 1) {
          imageContainer.classList.add('hv-image-tabs__image-container--no-top-right-radius');
        }
      };

      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const tabNumber = this.dataset.tab;

          // Remove active state from all tabs
          tabs.forEach(t => {
            t.classList.remove('hv-image-tabs__tab--active');
            t.classList.add('hv-image-tabs__tab--inactive');
            const dot = t.querySelector('.hv-image-tabs__tab-radio-dot');
            if (dot) dot.remove();
          });

          // Add active state to clicked tab
          this.classList.add('hv-image-tabs__tab--active');
          this.classList.remove('hv-image-tabs__tab--inactive');
          const radio = this.querySelector('.hv-image-tabs__tab-radio');
          if (radio) {
            const dot = document.createElement('div');
            dot.className = 'hv-image-tabs__tab-radio-dot';
            radio.appendChild(dot);
          }

          // Hide all images and show the selected one
          images.forEach(img => {
            img.classList.remove('hv-image-tabs__image--active');
          });

          const activeImage = section.querySelector(`.hv-image-tabs__image[data-tab="${tabNumber}"]`);
          if (activeImage) {
            activeImage.classList.add('hv-image-tabs__image--active');
          }

          // Trigger custom event for tab change
          section.dispatchEvent(new CustomEvent('tabChanged', {
            detail: { tabNumber, element: section }
          }));

          // Reflect container radius depending on active tab position
          updateContainerRadius();
        });

        // Keyboard accessibility
        tab.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
        });

      // Initial state on load
      updateContainerRadius();
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.getElementById('logos-wrapper-{{ section_id }}');
    if (!wrapper) return;

    const tabletBreakpoint = 990;

    // Setup infinite scroll for tablet and mobile
    if (window.innerWidth < tabletBreakpoint) {
      // Clone the content to create a seamless loop
      const items = wrapper.innerHTML;
      wrapper.innerHTML = items + items;
    }

    // Update on resize
    window.addEventListener('resize', () => {
      if (window.innerWidth < tabletBreakpoint) {
        if (!wrapper.innerHTML.includes('logos-slider__slide--clone')) {
          const items = wrapper.innerHTML;
          wrapper.innerHTML = items + items;
        }
      } else {
        // Remove clones on desktop
        const originalContent = wrapper.innerHTML.slice(0, wrapper.innerHTML.length / 2);
        wrapper.innerHTML = originalContent;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
